module.exports = __webpack_public_path__ + "img/20.d70bb1fa.webp";